import React from 'react';

const Termination: React.FC = () => {
  return (
    <div className="space-y-4">
      <h4 className="text-lg font-semibold mb-2">Termination by User</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>Cancel subscription anytime through account settings</li>
        <li>Request account deletion via support</li>
        <li>Service access continues until the end of your billing period</li>
      </ul>

      <h4 className="text-lg font-semibold mb-2 mt-6">Termination by FeelHeard.me</h4>
      <ul className="list-disc pl-5 space-y-2">
        <li>We may terminate or suspend your account for:
          <ul className="list-disc pl-5 mt-2">
            <li>Terms of Service violations</li>
            <li>Abusive behavior or misuse</li>
            <li>Non-payment of fees</li>
          </ul>
        </li>
        <li>Immediate termination for serious violations</li>
        <li>No refund for termination due to violations</li>
        <li>Prorated refund for service discontinuation</li>
      </ul>

      <div className="bg-[#C2A4D6]/10 p-4 rounded-lg mt-6">
        <p className="text-sm text-gray-600">
          Upon termination, you will lose access to all features and content associated with your account. 
          We reserve the right to retain certain data as required by law or for legitimate business purposes.
        </p>
      </div>
    </div>
  );
};

export default Termination;